import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=14bafdd6&"
import script from "./AdminCreate.vue?vue&type=script&lang=js&"
export * from "./AdminCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports